import './contact.css';
import Swal from 'sweetalert2';
import useScrollReveal from '../../hooks/useScrollReveal';

function Contact() {
    const sectionRef = useScrollReveal();

    const onSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const data = {
            name: formData.get('Name'),
            email: formData.get('Email'),
            phone: formData.get('Phone'),
            message: formData.get('Message'),
        };

        try {
            const response = await fetch('https://formspree.io/f/maqdkdbn', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Your message has been sent.',
                    icon: 'success',
                    confirmButtonText: 'Cool',
                    confirmButtonColor: '#7c3aed',
                });
                event.target.reset();
            } else {
                throw new Error('Network response was not ok.');
            }
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: 'Failed to send message.',
                icon: 'error',
                confirmButtonText: 'Try Again',
                confirmButtonColor: '#ef4444',
            });
        }
    };

    return (
        <div className="Contact" id="contact" ref={sectionRef}>
            <h1 className="scroll-reveal">
                Get in <span className="highlight-gradient">Touch</span>{' '}
                <i className="fas fa-headset"></i>
            </h1>
            <p className="contact-subtitle scroll-reveal delay-1">
                Have a question or want to work together? Let's talk!
            </p>

            <div className="contact-container scroll-reveal delay-2">
                <div className="contact-info-side">
                    <div className="contact-info-card">
                        <div className="info-item">
                            <div className="info-icon">
                                <i className="fas fa-envelope"></i>
                            </div>
                            <div>
                                <h4>Email</h4>
                                <p>mohadhl2005@gmail.com</p>
                            </div>
                        </div>
                        <div className="info-item">
                            <div className="info-icon">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <div>
                                <h4>Location</h4>
                                <p>Blida, Algeria</p>
                            </div>
                        </div>
                        <div className="info-item">
                            <div className="info-icon">
                                <i className="fas fa-clock"></i>
                            </div>
                            <div>
                                <h4>Availability</h4>
                                <p>Open to freelance & collaboration</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contact-form-side">
                    <form onSubmit={onSubmit}>
                        <div className="input-group">
                            <span className="icon">
                                <i className="fas fa-user"></i>
                            </span>
                            <input
                                type="text"
                                placeholder="Your Name"
                                aria-label="Name"
                                name="Name"
                                required
                            />
                        </div>

                        <div className="input-group">
                            <span className="icon">
                                <i className="fas fa-envelope"></i>
                            </span>
                            <input
                                type="email"
                                placeholder="Your Email"
                                aria-label="Email"
                                name="Email"
                                required
                            />
                        </div>

                        <div className="input-group">
                            <span className="icon">
                                <i className="fas fa-phone"></i>
                            </span>
                            <input
                                type="tel"
                                placeholder="Phone (Optional)"
                                aria-label="Phone"
                                name="Phone"
                            />
                        </div>

                        <div className="input-group textarea-group">
                            <span className="icon">
                                <i className="fas fa-comment"></i>
                            </span>
                            <textarea
                                placeholder="Your Message"
                                aria-label="Message"
                                name="Message"
                                required
                            ></textarea>
                        </div>

                        <button type="submit" className="submit-btn">
                            Send Message <i className="fas fa-paper-plane"></i>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Contact;